<template>
  <nav class="sp-table-page-navigation" part="page-navigation" :aria-label="navigationLabel">
    <span class="sp-table-page-navigation__status" part="page-status" aria-live="polite">{{ status }}</span>

    <TablePageStep :label="previousLabel" :disabled="isFirstPage" @activate="goToPreviousPage" />
    <TablePageStep :label="nextLabel" :disabled="isLastPage" @activate="goToNextPage" />
  </nav>
</template>

<script setup>
import { computed } from "vue";

import { t } from "#ce/shared/components-i18n";
import TablePageStep from "./TablePageStep.ce.vue";

const props = defineProps({
  page: {
    type: Number,
    default: 1,
  },
  pageCount: {
    type: Number,
    default: 1,
  },
  isFirstPage: {
    type: Boolean,
    default: false,
  },
  isLastPage: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["change"]);

const navigationLabel = computed(() => t("table_pagination"));
const previousLabel = computed(() => t("table_previous_page"));
const nextLabel = computed(() => t("table_next_page"));
const status = computed(() => t("table_page_status", { page: props.page, pages: props.pageCount }));

function goToPreviousPage() {
  emit("change", props.page - 1);
}

function goToNextPage() {
  emit("change", props.page + 1);
}
</script>

<style lang="scss" scoped>
.sp-table-page-navigation {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-comp-table-pager-gap, var(--sp-ref-spacing-6));
}
</style>
